// extracted by mini-css-extract-plugin
export default {"like":"index_like_NUJ8Q","likeIcon":"index_likeIcon_-zo1R"};